'use client';

import { isBrowser } from '../../helpers/environment/isBrowser';
import { Button } from '../Clickables/Buttons/Button';

export const CookiePreferencesLink = () => {
  return (
    <Button
      aria-label="cookie-preferences"
      onClick={() => {
        if (isBrowser() && window.Osano !== undefined) {
          window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
        }
      }}
      variant="textDeprecatedLight"
      className="body-text-md"
    >
      Cookie Preferences
    </Button>
  );
};
